import * as Yup from 'yup'

export const AddSinglePaymentSchema = Yup.object().shape({
  contractorId: Yup.string().required('Contractor is required'),
  amount: Yup.string().required('Amount is required').min(6, 'Amount is invalid'),
})
